<template>
  <GekkoButton 
    @click="openOnboardingWizard"
    :text="$gettext('Open wizard')"
    variant="link text-blue"
    :icon="'fa-solid fa-sparkles'"
    icon-right
    class="display-none"
  />
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import GekkoButton from "@/components/GekkoButton";

export default {
  name: 'onboarding-wizard-link',
  components: { 
    GekkoButton 
  },
  props: {
    openWelcome: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({ 
      getCompanyBelongsToUser: 'main/getCompanyBelongsToUser',
    })
  },
  created () {
    if (this.$route.query.welcome === 'yes' && this.getCompanyBelongsToUser) {
      this.openOnboardingWizard()
    }
  },
  methods: {
    ...mapMutations({ 
      openOnboardingWizard: 'onboarding/OPEN_ONBOARDING_WIZARD',
    })
  },
}
</script>

<style lang="scss">
</style>

